import { get } from "./request";
import { getFilePreviewUrl } from "./attachmentPreview";

export async function getCurrentUserAvatarUrl() {
  const res = await get("/user/getCurrentUserInfo");
  const raw = res?.data ?? res;
  const data =
    raw && typeof raw === "object" && raw.data && typeof raw.data === "object"
      ? raw.data
      : raw;

  const avatarIdOrUrl =
    data?.attachmentUuid ??
    data?.avatarAttachmentUuid ??
    data?.avatarUrl ??
    "";

  if (!avatarIdOrUrl) return "";

  const isLikelyId =
    typeof avatarIdOrUrl === "string" && !avatarIdOrUrl.startsWith("http");
  const url = isLikelyId
    ? await getFilePreviewUrl(avatarIdOrUrl)
    : avatarIdOrUrl;

  return url || "";
}
